/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Revenue from './component/revenue'
import { Spin } from 'antd'

class ClubRevenue extends React.Component {
  static defaultProps = {
    revenueList: {
      income: [],
      settle: [],
      methods: [],
    },
  }

  componentWillUnmount() {
    this.props.getClubRevenue({
      income: [],
      settle: [],
      methods: [],
    }) //清除
  }

  render() {
    const { revenueList } = this.props
    return (
      <Revenue
        list={revenueList}
        fetchClubRevenue={this.props.fetchClubRevenue}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    revenueList: state.getClubRevenue.revenueList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubRevenue))



// WEBPACK FOOTER //
// ./src/containers/ClubRevenue/index.js